module.exports = __webpack_public_path__ + "img/54.cc1b7bdf.b37c2890.svg";